import {defineRegleNuxtPlugin} from '@regle/nuxt/setup';
import {defaultRegleConfig} from '../defaultConfig';

export default defineRegleNuxtPlugin(() => defaultRegleConfig);
